module.exports = __webpack_public_path__ + "img/back_02.15877744.png";